"use client";

import { TableHead, TableRow } from "@/shadcn-components/ui/table";
import { Button } from "@/shadcn-components/ui/button";
import { Input } from "@/shadcn-components/ui/input";
import {
  historyTh,
  HISTORY_DEAL_COL_WIDTHS,
} from "./historyDesktopTableLayout";
import type { HistorySortFilterTableHeaderProps } from "./historySortFilterHeaderTypes";

const W = HISTORY_DEAL_COL_WIDTHS;

export function HistoryDealsTableHeader({
  sortColumn,
  sortDirection,
  filters,
  showFilterInputs,
  onSort,
  onFilterChange,
  renderSortIcon,
  renderFilterDropdown,
}: HistorySortFilterTableHeaderProps) {
  void sortColumn;
  void sortDirection;

  const sortButton = (column: string, label: string) => (
    <Button
      variant="ghost"
      size="sm"
      className="h-5 gap-0 px-0.5 text-[11px] font-medium"
      onClick={() => onSort(column)}
    >
      {label}
      {renderSortIcon(column)}
    </Button>
  );

  const headerCell = (
    column: string,
    label: string,
    placeholder: string,
    widthClass: string,
    alignRight = false
  ) => (
    <TableHead
      className={`${historyTh} ${widthClass}${alignRight ? " text-right" : ""}`}
    >
      <div className={`flex items-center${alignRight ? " justify-end" : ""}`}>
        {sortButton(column, label)}
        {!showFilterInputs && renderFilterDropdown(column, placeholder)}
      </div>
    </TableHead>
  );

  const filterCell = (
    column: string,
    placeholder: string,
    widthClass: string
  ) => (
    <TableHead className={`h-7 px-1.5 py-0.5 ${widthClass}`}>
      <Input
        placeholder={placeholder}
        value={filters[column] || ""}
        onChange={(e) => onFilterChange(column, e.target.value)}
        className="h-5 px-1.5 text-[11px]"
      />
    </TableHead>
  );

  return (
    <>
      <TableRow>
        {headerCell("time", "Time", "Filter time...", W.time)}
        {headerCell("symbol", "Symbol", "Filter symbols...", W.symbol)}
        {headerCell("deal", "Deal", "Filter deal...", W.deal, true)}
        {headerCell("type", "Type", "Filter type...", W.type)}
        {headerCell("direction", "Direction", "Filter direction...", W.direction)}
        {headerCell("lots", "Lots", "Filter lots...", W.lots, true)}
        {headerCell("price", "Price", "Filter price...", W.price, true)}
        {headerCell("tp", "TP", "Filter TP...", W.tp, true)}
        {headerCell("sl", "SL", "Filter SL...", W.sl, true)}
        {headerCell("commission", "Commission", "Filter commission...", W.commission, true)}
        {headerCell("pnl", "P&L", "Filter P&L...", W.pnl, true)}
        {headerCell("change", "Change %", "Filter change...", W.change, true)}
      </TableRow>

      {showFilterInputs && (
        <TableRow className="border-b bg-background">
          {filterCell("time", "Filter time...", W.time)}
          {filterCell("symbol", "Filter symbols...", W.symbol)}
          {filterCell("deal", "Filter deal...", W.deal)}
          {filterCell("type", "Filter type...", W.type)}
          {filterCell("direction", "Filter direction...", W.direction)}
          {filterCell("lots", "Filter lots...", W.lots)}
          {filterCell("price", "Filter price...", W.price)}
          {filterCell("tp", "Filter TP...", W.tp)}
          {filterCell("sl", "Filter SL...", W.sl)}
          {filterCell("commission", "Filter commission...", W.commission)}
          {filterCell("pnl", "Filter P&L...", W.pnl)}
          {filterCell("change", "Filter change...", W.change)}
        </TableRow>
      )}
    </>
  );
}
